"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpandingInputButton = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var WindowCloseIcon_1 = __importDefault(require("mdi-react/WindowCloseIcon"));
var react_1 = require("react");
var Form_1 = require("../../legacy/Form");
require("./ExpandingInputButton.css");
var classnames_1 = __importDefault(require("classnames"));
var MagnifyIcon_1 = __importDefault(require("mdi-react/MagnifyIcon"));
var ExpandingInputButton = function (_a) {
    var icon = _a.icon, placeholder = _a.placeholder, _onChange = _a.onChange, _b = _a.startingValue, _value = _b === void 0 ? "" : _b, restProps = __rest(_a, ["icon", "placeholder", "onChange", "startingValue"]);
    var _c = __read((0, react_1.useState)(_value), 2), value = _c[0], setValue = _c[1];
    var _d = __read((0, react_1.useState)(false), 2), focused = _d[0], setFocused = _d[1];
    var onChange = function (e) {
        _onChange && _onChange(e.target.value);
        setValue(e.target.value);
    };
    var onFocus = function () { setFocused(true); };
    var onBlur = function () { setFocused(false); };
    var onClear = function () {
        _onChange && _onChange("");
        setValue("");
        setFocused(false);
    };
    var isExpanded = focused || value.trim().length > 0;
    var containerClassName = (0, classnames_1.default)("vsx-expanding-input-button", "vsx-styled-form", isExpanded && "vsx-expanding-input-button-focused");
    return ((0, jsx_runtime_1.jsxs)("div", __assign({}, restProps, { className: containerClassName, onFocus: onFocus, onBlur: onBlur }, { children: [(0, jsx_runtime_1.jsx)("span", __assign({ className: "vsx-expanding-input-button-icon" }, { children: icon !== null && icon !== void 0 ? icon : (0, jsx_runtime_1.jsx)(MagnifyIcon_1.default, {}) })), (0, jsx_runtime_1.jsx)(Form_1.Input, { placeholder: placeholder, type: "text", onChange: onChange, value: value }), isExpanded && (0, jsx_runtime_1.jsx)("span", __assign({ onClick: onClear, "aria-label": "close" }, { children: (0, jsx_runtime_1.jsx)(WindowCloseIcon_1.default, { className: "vsx-window-close-icon" }) }))] })));
};
exports.ExpandingInputButton = ExpandingInputButton;
